// angular import
import { Component } from '@angular/core';

// project import
import { SharedModule } from 'src/app/shared/shared/shared.module';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {}
